module.exports = __webpack_public_path__ + "img/winerackdog08.2aec0e9e.jpg";